import {BACKEND_URL} from "../../../configs";
import {globalFetchConfig} from "../../../api/apiConfiguration";
import {KnowledgeScope} from "../../../api/generated";
import {UpdateKnowledgeRecordRequest} from "../assistant/franchiseTypes";
import {readErrorMessage} from "./knowledgeDefinitionsApi";

interface UpdateKnowledgeRecordsRequest {
    scope: KnowledgeScope;
    botPublicId?: string;
    franchisePublicId?: string;
    locationPublicId?: string;
    knowledgeRecords: UpdateKnowledgeRecordRequest[];
}

export const updateKnowledgeRecords = async (request: UpdateKnowledgeRecordsRequest): Promise<void> => {
    const response = await globalFetchConfig(`${BACKEND_URL}/api/private/knowledge`, {
        method: "PUT",
        body: JSON.stringify(request)
    });
    if (!response.ok) {
        throw new Error(await readErrorMessage(response, "Failed to update knowledge records"));
    }
}
